import classNames from 'classnames';
import { FC, PropsWithChildren } from 'react';

type ActionButtonGroupProps = {
  size?: 'base' | 'small';
  className?: string;
};

const GAP_CLASSNAMES: Record<ActionButtonGroupProps['size'], string> = {
  base: 'space-x-2',
  small: 'space-x-1.5',
};

const ActionButtonGroup: FC<PropsWithChildren<ActionButtonGroupProps>> = ({
  size = 'base',
  className,
  children,
}) => {
  return (
    <div
      className={classNames(
        'flex flex-row items-center',
        GAP_CLASSNAMES[size],
        className,
      )}
    >
      {children}
    </div>
  );
};

export default ActionButtonGroup;
